import React, {useContext, useEffect, useState} from "react";
import begginingimg from "../image/beginning.svg";
import flashrotate from "../image/flashrotate.svg";
import flash from "../image/flash.svg";
import destinationimg from "../image/destination.svg";
import {UseContext} from "../context";
import loacationimg from "../image/placeholder 1.svg";
import axios from "axios";
import Loadingcom from "./allcomponent/Loading";
import {Navigate, useNavigate} from "react-router-dom";
import "./Scroll.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import firebase from "firebase/compat/app";
import "firebase/database";
import humanface from "../image/human1.svg";
import humanbody from "../image/human2.svg";
import {url} from "../url";
import {IoClose} from "react-icons/io5";
import searchicon from "../image/search1 (2).svg";
import { getSocket, SOCKET_EVENTS } from "../socket";
import DriverPermissions from "../DriverPermissions";
import PendingApprovalScreen from "./allcomponent/PendingApproval";


const TravelCard = () => {
    const {
        setShowhomecom,
        showhomecom,
        allcity,
        setAllcity,
        loading,
        setLoading,
        showexit,
        setShownav,
        getmyprof,
        getprofloading,
        alltravelfordriver,
        setAlltravelfordriver,
        setShowtrinprogress,
        setShowhis,
        setShowhistrinprogress,
        setShoweverytravelcard
    } = useContext(UseContext);

    const [travelloading, setTravelloading] = useState(true);
    const [travelRetryTick, setTravelRetryTick] = useState(0);
    const [cityValue, setCityValue] = useState("");
    const [descityValue, setDescityValue] = useState("");
    const navigate = useNavigate();

    // const firebaseConfig = {
    //   apiKey: "AIzaSyBrdp9Kmf2JIdB35mqCDLWYY58rb-3a8YI",
    //   authDomain: "travel-f0c35.firebaseapp.com",
    //   projectId: "travel-f0c35",
    //   storageBucket: "travel-f0c35.appspot.com",
    //   messagingSenderId: "505809502099",
    //   appId: "1:505809502099:web:16940417a34e02c745b266",
    //   measurementId: "G-9CWTG47NL5",
    // };
    // firebase.initializeApp(firebaseConfig);
    // const database = firebase.database();

    // useEffect(() => {
    //   const tripref = database.ref("trips");
    //   tripref.on("child-added", (data) => {
    //     const newTrip = data.val();
    //   });
    // }, []);

    const [minprice, setMinprice] = useState("");
    const [maxprice, setMaxprice] = useState("");

    function Getdata() {
        axios
            .get(`${url}/states/v1/get-city-list?withoutPagination=true`)
            .then((res) => {
                if (res.status === 200) {
                    setLoading(false);
                    setAllcity(res.data.data);
                } else {
                    setLoading(true);
                }
            })
            .catch((e) => {
                setLoading(true);
            });
    }

    const [errormtravel, setErrormtravel] = useState("");
    const [origincityf, setOrigincityf] = useState(false);
    const [destinationf, setDestinationf] = useState(false);
    const [origincityid, setOrigincityid] = useState("");
    const [descityid, setDescityid] = useState("");

    // useEffect(() => {
    //   if (cityValue === "") {
    //     setOrigincityid("");
    //   }
    //   if (descityValue === "") {
    //     setDescityid("");
    //   }
    //   if (minprice === "") {
    //     setMinprice("");
    //   }
    //   if (maxprice === "") {
    //     setMaxprice("");
    //   }
    // }, [cityValue, descityValue, minprice, maxprice]);

    const [isCitySelected, setIsCitySelected] = useState(false);
    const [cityvalueinput, setCityvalueinput] = useState("");
    const [desvalueinput, setDesvalueinput] = useState("");
    const [isDesSelected, setIsDesSelected] = useState(false);
    const [noActiveTravel, setNoActiveTravel] = useState(false)
    const [socketRefresh, setSocketRefresh] = useState(false)


    // useEffect(() => {
    //     axios.get(`${url}/travel/v1/get-travels-driver-accept`, {
    //         headers: {
    //             Authorization: `Bearer ${localStorage.getItem("token")}`
    //         }
    //     }).then(res => {
    //         console.log(res.data);
    //         setLoading(false)
    //         if (res.data.message === "در حال حاضر سفر فعال دارید") {
    //             setNoActiveTravel(false)
    //         } else {
    //             setNoActiveTravel(true)
    //         }
    //     }).catch(err => {
    //         setLoading(true)
    //     })
    // }, [])


    useEffect(() => {
        let apiUrl = `${url}/travel/v1/get-travels-driver-accept/?`;
        if (origincityid) {
            apiUrl += `origin_city=${origincityid}`;
        }
        if (descityid) {
            apiUrl += `&destination_city=${descityid}`;
        }
        if (minprice) {
            apiUrl += `&min_price=${minprice}`;
        }
        if (maxprice) {
            apiUrl += `&max_price=${maxprice}`;
        }
        const controller = new AbortController();
        let cancelled = false;
        setErrormtravel("");
        setTravelloading(true)
        axios
            .get(apiUrl, {
                timeout: 15000,
                signal: controller.signal,
                headers: {
                    // "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                if (cancelled) return;
                if (res.status === 200) {
                    if (res.data.message === "در حال حاضر سفر فعال دارید") {
                        setNoActiveTravel(false)
                        setLoading(false)
                    } else {
                        setNoActiveTravel(true)
                        setLoading(false)
                    }
                    setAlltravelfordriver(res.data.data.docs);
                    setTravelloading(false);
                    setErrormtravel("");
                } else {
                    setErrormtravel("دریافت فهرست سفرها ناموفق بود.");
                    setTravelloading(false);
                }
            })
            .catch((error) => {
                if (cancelled) return;
                setErrormtravel(error.response?.data?.message || "ارتباط برقرار نشد. دوباره تلاش کنید.");
                setTravelloading(false);
            });
        return () => {
            cancelled = true;
            controller.abort();
        };
    }, [origincityid, descityid, minprice, maxprice, socketRefresh, travelRetryTick, setAlltravelfordriver, setLoading]);

    // --- WebSocket: سفر جدید قابل پذیرش یا برداشته شدن سفر — لیست خودکار به‌روز می‌شود ---
    useEffect(() => {
        const socket = getSocket();
        if (!socket) return;

        const refreshList = () => setSocketRefresh(prev => !prev);

        socket.on(SOCKET_EVENTS.TRAVEL_AVAILABLE, refreshList);
        socket.on(SOCKET_EVENTS.TRAVEL_UNAVAILABLE, refreshList);

        return () => {
            socket.off(SOCKET_EVENTS.TRAVEL_AVAILABLE, refreshList);
            socket.off(SOCKET_EVENTS.TRAVEL_UNAVAILABLE, refreshList);
        };
    }, []);


    function cityChange(e) {
        setCityValue(e.name);
        setOrigincityid(e._id);
        setIsCitySelected(true);
    }

    function deschange(e) {
        setDescityValue(e.name);
        setDescityid(e._id);
        setIsDesSelected(true);
    }

    const [isShowDropdown, setIsShowDropdown] = useState(false);
    const showeverytravelc = (item) => {
        console.log(item._id)
        navigate(`/home/travelinformation/${item._id}`);
        setShowhomecom(false);
        setShownav(false);
    };

    function handleshowEditprof() {
        navigate("/Edit");
        setShownav(false);
    }

    function GoToTravelActive () {
        setShowtrinprogress(true);
        setShowhis(false);
        setShowhistrinprogress(true);
        setShoweverytravelcard(false);
        navigate("/history");

    }

    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <>
                    {getprofloading === false ? (
                        <>
                            {getmyprof.status === "profile_not_completed" ? (
                                <Navigate to="/UserandCarinformation"/>
                            ) : (
                                <>
                                    {getmyprof.status === "pending" ? (
                                        <div
                                            className="w-full flex flex-col h-full  overflow-auto mb-[100px] lg:mb-[88px]">
                                            {getmyprof.profile_image.fileName === "" ? (
                                                <>
                                                    <div
                                                        className="bg-grayinput border-[2px] border-black m-4  rounded-[50%] w-[40px] h-[40px] cursor-pointer  "
                                                        onClick={handleshowEditprof}
                                                    >
                                                        <div className="w-full flex justify-center mt-1">
                                                            <img alt="" className="" src={humanface}></img>
                                                        </div>
                                                        <div className="w-full flex justify-center mt-1">
                                                            <img alt="" src={humanbody}></img>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <div
                                                    className="border-[1px] border-gray-500 rounded-[50%] mr-2 mt-2 w-[70px] h-[70px] cursor-pointer">
                                                    <img
                                                        alt=""
                                                        onClick={handleshowEditprof}
                                                        className="rounded-[50%] w-[70px] h-[70px] cursor-pointer"
                                                        src={`${url}/${getmyprof.profile_image.fileName}`}
                                                    ></img>
                                                </div>
                                            )}
                                            <PendingApprovalScreen />
                                        </div>
                                    ) : (
                                        <div
                                            className="driver-home-content h-full relative w-full flex flex-col items-center justify-center">
                                            <div
                                                className={`w-[100%] ${errormtravel ? "absolute top-0" : ""
                                                } driver-home-filter-row flex justify-center items-center `}
                                            >
                                                <div
                                                    className={`driver-home-toolbar w-full flex mx-4 gap-4 z-10 mt-6`}
                                                >
                                                    <div className="w-[10%]">
                                                        {getmyprof.profile_image.fileName === "" ? (
                                                            <>
                                                                <div
                                                                    className="bg-grayinput border-[2px]  border-black m-4  rounded-[50%] w-[40px] h-[40px] cursor-pointer  "
                                                                    onClick={handleshowEditprof}
                                                                >
                                                                    <div className="w-full flex justify-center mt-1">
                                                                        <img
                                                                            alt=""
                                                                            className=""
                                                                            src={humanface}
                                                                        ></img>
                                                                    </div>
                                                                    <div className="w-full flex justify-center mt-1">
                                                                        <img alt="" src={humanbody}></img>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div
                                                                className="border-[1px] border-gray-500 rounded-[50%]  w-[40px] h-[40px] cursor-pointer">
                                                                <img
                                                                    alt=""
                                                                    onClick={handleshowEditprof}
                                                                    className="rounded-[50%] w-[40px] h-[40px] cursor-pointer"
                                                                    src={`${url}/${getmyprof.profile_image.fileName}`}
                                                                ></img>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div
                                                        className={`driver-filter-panel cursor-pointer w-[90%] bg-grayinput rounded-[10px] scrollbar z-10`}
                                                    >
                                                        <div className="  h-[40px] items-center   flex flex-col">
                                                            <div
                                                                className=" flex items-center h-full w-full col-span-1  justify-between"
                                                                onClick={
                                                                    showexit === false
                                                                        ? () => {
                                                                            setIsShowDropdown(!isShowDropdown);
                                                                            if (isShowDropdown === false) {
                                                                                setOrigincityf(false);
                                                                                setDestinationf(false);
                                                                            }
                                                                            Getdata();
                                                                        }
                                                                        : null
                                                                }
                                                            >
                                                                <img
                                                                    alt=""
                                                                    src={loacationimg}
                                                                    className="mr-4"
                                                                />
                                                                <input
                                                                    className="cursor-pointer w-full pr-4  border-none outline-none bg-transparent"
                                                                    placeholder="انتخاب فیلتر"
                                                                    readOnly
                                                                />

                                                                <img
                                                                    alt=""
                                                                    className="  flex items-center pl-4 justify-end col-span-1  "
                                                                    src={noActiveTravel ? (isShowDropdown ? flashrotate : flash) : null}
                                                                ></img>
                                                            </div>
                                                        </div>
                                                        {noActiveTravel ?
                                                            isShowDropdown ? (
                                                                <div className="driver-filter-panel__body pb-5">
                                                                    <div className="flex flex-row mt-4 mx-4 gap-4">
                                                                        <div className="w-[50%] relative scrollbar">
                                                                            <div
                                                                                className="w-full flex items-center bg-white rounded-[5px]">
                                                                                <input
                                                                                    onClick={() => {
                                                                                        setOrigincityf(!origincityf);
                                                                                    }}
                                                                                    placeholder="انتخاب مبدا"
                                                                                    value={cityValue}
                                                                                    className="h-[40px] pr-2 outline-none rounded-[5px] cursor-pointer w-full  border-none"
                                                                                    readOnly
                                                                                ></input>
                                                                                <IoClose className="ml-2"
                                                                                         onClick={() => {
                                                                                             setCityValue("");
                                                                                             setOrigincityid("");
                                                                                         }}
                                                                                />
                                                                            </div>

                                                                            {origincityf && (
                                                                                <div
                                                                                    className="absolute w-full shadow-navboxshadow">
                                                                                    <div
                                                                                        className="flex flex-row bg-white border-b-2 cursor-pointer border-gray-500 h-[30px]">
                                                                                        <input
                                                                                            onChange={(e) => {
                                                                                                const value = e.target.value;
                                                                                                setCityvalueinput(value);

                                                                                                if (value) {
                                                                                                    setIsCitySelected(false);
                                                                                                }
                                                                                            }}
                                                                                            className="text-black cursor-pointer placeholder:text-[14px] placeholder:text-black rounded-[5px] outline-none pr-4 w-full"
                                                                                            placeholder="جست و جو"
                                                                                        ></input>
                                                                                        <img
                                                                                            alt=""
                                                                                            className=""
                                                                                            src={searchicon}
                                                                                        ></img>

                                                                                    </div>
                                                                                    <ul
                                                                                        id="scrollbar"
                                                                                        className={`w-full bg-white overflow-auto z-20 ${loading
                                                                                            ? "h-[160px]"
                                                                                            : "max-h-[170px]"
                                                                                        }`}
                                                                                    >
                                                                                        {loading === false ? (
                                                                                            (isCitySelected
                                                                                                    ? allcity
                                                                                                    : allcity.filter((city) =>
                                                                                                        city.name
                                                                                                            .toLowerCase()
                                                                                                            .includes(
                                                                                                                cityvalueinput.toLowerCase()
                                                                                                            )
                                                                                                    )
                                                                                            ).map((item) => (
                                                                                                <li
                                                                                                    key={item._id}
                                                                                                    className="py-[5px] hover:bg-slate-200 pr-4 hover:text-black hover:w-full cursor-pointer"
                                                                                                    onClick={() => {
                                                                                                        cityChange(item);
                                                                                                        setIsShowDropdown(true);
                                                                                                        setOrigincityf(false);
                                                                                                        setCityvalueinput("");
                                                                                                    }}
                                                                                                >
                                                                                                    <div
                                                                                                        className="h-full flex items-center">
                                                                                                        <p>{item.name}</p>
                                                                                                    </div>
                                                                                                </li>
                                                                                            ))
                                                                                        ) : (
                                                                                            <div
                                                                                                className="flex h-full justify-center items-center">
                                                                                                <Loadingcom/>
                                                                                            </div>
                                                                                        )}
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="w-[50%] relative scrollbar">
                                                                            <div
                                                                                className="w-full bg-white rounded-[5px] flex items-center">
                                                                                <input
                                                                                    onClick={() => {
                                                                                        setDestinationf(!destinationf);
                                                                                    }}
                                                                                    value={descityValue}
                                                                                    placeholder="انتخاب مقصد"
                                                                                    className="h-[40px] pr-2 cursor-pointer rounded-[5px] w-full outline-none border-none"
                                                                                    readOnly
                                                                                ></input>
                                                                                <IoClose className="ml-2"
                                                                                         onClick={() => {
                                                                                             setDescityValue("")
                                                                                             setDescityid("")
                                                                                         }}
                                                                                />

                                                                            </div>
                                                                            {destinationf && (
                                                                                <div
                                                                                    className="absolute w-full shadow-navboxshadow   ">
                                                                                    <div
                                                                                        className="flex flex-row bg-white border-b-2 border-gray-500  h-[30px]">
                                                                                        <input
                                                                                            onChange={(e) => {
                                                                                                const value = e.target.value;
                                                                                                setDesvalueinput(value);
                                                                                                if (value) {
                                                                                                    setIsDesSelected(false);
                                                                                                }
                                                                                            }}
                                                                                            className="  text-black  placeholder:text-[14px] placeholder:text-black  rounded-[5px] outline-none pr-4  w-full"
                                                                                            placeholder="جست و جو"
                                                                                        ></input>
                                                                                        <img
                                                                                            className=""
                                                                                            alt=""
                                                                                            src={searchicon}
                                                                                        ></img>
                                                                                    </div>
                                                                                    <ul
                                                                                        id="scrollbar"
                                                                                        className={`w-full bg-white overflow-auto z-20 ${loading
                                                                                            ? "h-[160px]"
                                                                                            : "max-h-[170px]"
                                                                                        }`}
                                                                                    >
                                                                                        {loading === false ? (
                                                                                            (isDesSelected
                                                                                                    ? allcity
                                                                                                    : allcity.filter((city) =>
                                                                                                        city.name
                                                                                                            .toLowerCase()
                                                                                                            .includes(
                                                                                                                desvalueinput?.toLowerCase()
                                                                                                            )
                                                                                                    )
                                                                                            ).map((item) => (
                                                                                                <li
                                                                                                    key={item._id}
                                                                                                    className="py-[5px] hover:bg-slate-200 pr-4 hover:text-black hover:w-full cursor-pointer"
                                                                                                    onClick={(e) => {
                                                                                                        deschange(item);
                                                                                                        setIsShowDropdown(true);
                                                                                                        setDestinationf(false);
                                                                                                        setDesvalueinput("");
                                                                                                    }}
                                                                                                >
                                                                                                    <div
                                                                                                        className="h-full flex items-center">
                                                                                                        <p>{item.name}</p>
                                                                                                    </div>
                                                                                                </li>
                                                                                            ))
                                                                                        ) : (
                                                                                            <div
                                                                                                className="flex h-full justify-center items-center">
                                                                                                <Loadingcom/>
                                                                                            </div>
                                                                                        )}
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    <div className="pr-4 mt-4">
                                                                        <p className="sm:text-[12px] xsm:text-[12px] lg:text-[16px] md:text-[16px]">
                                                                            بازه ی انتخابی قیمت :
                                                                        </p>
                                                                    </div>
                                                                    <div className="flex w-full mx-4 fex-col mt-4">
                                                                        <div className="w-[50%] flex flex-row">
                                                                            <div className="w-[1%]">
                                                                                <p>از</p>
                                                                            </div>
                                                                            <div
                                                                                className="border-b-[2px] w-[49%]  border-b-blue-500 mr-8 ">
                                                                                <input
                                                                                    type="number"
                                                                                    value={minprice}
                                                                                    className="w-full bg-transparent outline-none"
                                                                                    onKeyPress={(e) => {
                                                                                        if (!/[0-9]/.test(e.key)) {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onInput={(e) => {
                                                                                        e.target.value =
                                                                                            e.target.value.replace(
                                                                                                /[^0-9]/g,
                                                                                                ""
                                                                                            );
                                                                                    }}
                                                                                    onChange={(e) => {
                                                                                        setMinprice(e.target.value);
                                                                                    }}
                                                                                ></input>
                                                                            </div>
                                                                        </div>
                                                                        <div className="w-[50%] flex flex-row">
                                                                            <div className="w-[1%]">
                                                                                <p>تا</p>
                                                                            </div>
                                                                            <div
                                                                                className="border-b-[2px] w-[49%] mr-8 border-b-blue-500 ">
                                                                                <input
                                                                                    type="number"
                                                                                    value={maxprice}
                                                                                    onKeyPress={(e) => {
                                                                                        if (!/[0-9]/.test(e.key)) {
                                                                                            e.preventDefault();
                                                                                        }
                                                                                    }}
                                                                                    onInput={(e) => {
                                                                                        e.target.value =
                                                                                            e.target.value.replace(
                                                                                                /[^0-9]/g,
                                                                                                ""
                                                                                            );
                                                                                    }}
                                                                                    onChange={(e) => {
                                                                                        setMaxprice(e.target.value);
                                                                                    }}
                                                                                    className="w-full bg-transparent outline-none"
                                                                                ></input>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <></>
                                                            )
                                                            :
                                                            null
                                                        }
                                                    </div>
                                                </div>
                                            </div>


                                            <div
                                                id="traveldiv"
                                                className={`w-full pt-4  h-full ${errormtravel ? "flex items-center" : ""
                                                }    h-full ${errormtravel && isShowDropdown === false
                                                    ? "mb-[110px]"
                                                    : "mb-[110px]"
                                                }   ${travelloading === false ? " overflow-auto" : ""}`}
                                            >
                                                <DriverPermissions />
                                                <div
                                                    className={`w-full  h-full top-6 space-y-4  `}
                                                >

                                                    {showhomecom === true && travelloading === false && !errormtravel ?
                                                        <>
                                                            {noActiveTravel ?
                                                                alltravelfordriver?.length > 0 ?
                                                                    (alltravelfordriver?.map((item) => {
                                                                            return (
                                                                                <div
                                                                                    key={item._id}
                                                                                    className={`lg:flex   ml-4 mr-4 ${showexit === false ? "cursor-pointer" : ""
                                                                                    } `}
                                                                                    onClick={
                                                                                        showexit === false
                                                                                            ? () => showeverytravelc(item)
                                                                                            : null
                                                                                    }
                                                                                >
                                                                                    <div
                                                                                        className="grid grid-rows-2 grid-flow-col w-full lg:w-[100%] bg-white rounded-[10px] py-2 shadow-md border-[1px] border-gray-200">
                                                                                        <div
                                                                                            className="grid grid-cols-2  row-span-1 ">
                                                                                            <div
                                                                                                className="flex  col-space-1 text-[14px] lg:text-[12px] lp:text-[14px]">
                                                                                                <img
                                                                                                    alt=""
                                                                                                    src={begginingimg}
                                                                                                    className="w-[12px] h-[20px] mr-4 mt-2 "
                                                                                                />
                                                                                                <p className="relative top-2 whitespace-nowrap pr-4">
                                                                                                    {item.origin_city?.name}
                                                                                                </p>
                                                                                                <p className="relative top-2 whitespace-nowrap pr-1">
                                                                                                    {item.address ? <>,</> : <></>}
                                                                                                </p>
                                                                                                <p className="relative top-2 whitespace-nowrap pr-1">
                                                                                                    {item.address ? (
                                                                                                        <>
                                                                                                            {item.address
                                                                                                                .split(" ")
                                                                                                                .slice(0, 3)
                                                                                                                .join(" ")}
                                                                                                            {item.address.split(" ").length >
                                                                                                            3
                                                                                                                ? "..."
                                                                                                                : ""}
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <p></p>
                                                                                                    )}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                className="flex justify-end mt-2 ml-4 text-[14px] font-[400]">
                                                                                                <DatePicker
                                                                                                    calendar={persian}
                                                                                                    locale={persian_fa}
                                                                                                    value={item.travel_date}
                                                                                                    readOnly
                                                                                                    style={{
                                                                                                        backgroundColor: "transparent",
                                                                                                        outline: "none",
                                                                                                        border: "none",
                                                                                                        width: "100px",
                                                                                                        marginTop: "-6px",
                                                                                                        fontSize: "16px",
                                                                                                        marginLeft: "-12px",
                                                                                                    }}
                                                                                                />
                                                                                                <p className="col-space-1 whitespace-nowrap">
                                                                                                    | {item.travel_hour_time}
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div
                                                                                            className="grid grid-cols-2 row-span-1">
                                                                                            <div
                                                                                                className="flex col-space-1 text-[14px]">
                                                                                                <div className="mr-4 mt-2">
                                                                                                    <img
                                                                                                        alt=""
                                                                                                        src={destinationimg}
                                                                                                        className="w-[12px] h-[20px] "
                                                                                                    />
                                                                                                </div>
                                                                                                <p className="relative top-2 whitespace-nowrap pr-4">
                                                                                                    {item.destination_city.name}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                className="col-span-1 flex justify-end mt-2 ml-4 text-[14px] font-[400] gap-1">
                                                                                                <p className="text-[#FFBF18FF] whitespace-nowrap mt-[2px]">
                                                                                                    {item.price - (item.price_paid ?? 0)}
                                                                                                </p>
                                                                                                <p>تومان</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    ) :
                                                                    <div
                                                                        className={` h-full w-full flex flex-col    items-center justify-center `}
                                                                    >
                                                                        <>
                                                                            <div id="reportdiv" className=" flex   ">
                                                                                <p>در حال حاضر سفری برای نمایش وجود ندارد!</p>
                                                                            </div>
                                                                        </>
                                                                    </div>

                                                                :
                                                                <div
                                                                    className={`bg-slate-200 cursor-pointer rounded-lg py-5 mx-5 px-5 items-center gap-x-2 ${noActiveTravel ? "hidden" : "flex"}`}
                                                                        onClick={GoToTravelActive}
                                                                >
                                                                    <div
                                                                        className="w-[10px] h-[10px] bg-emerald-500 rounded-full"></div>
                                                                    <p>{loading ? (
                                                                        <Loadingcom/>) : "شما یک سفر فعال دارید"}</p>
                                                                </div>
                                                            }



                                                        </>
                                                        : (
                                                            <div
                                                                className={` h-full w-full flex flex-col    items-center justify-center `}
                                                            >
                                                                <>
                                                                    <div id="reportdiv" className=" flex   ">
                                                                        {errormtravel ? (
                                                                            <div className="flex flex-col items-center gap-3 px-4 text-center">
                                                                                <p>{errormtravel}</p>
                                                                                <button
                                                                                    type="button"
                                                                                    className="rounded-[10px] bg-[#100E34] px-5 py-2 text-white"
                                                                                    onClick={() => setTravelRetryTick((tick) => tick + 1)}
                                                                                >
                                                                                    تلاش مجدد
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            travelloading === true && (
                                                                                <div className="mt-4">
                                                                                    <Loadingcom/>
                                                                                </div>
                                                                            )
                                                                        )}
                                                                    </div>
                                                                </>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                            {/* <div
                        id="traveldiv"
                        className={`w-full pt-4 space-y-4 ${
                          errormtravel ? "flex items-center" : ""
                        }    h-full ${
                          errormtravel && isShowDropdown === false
                            ? "mb-[110px]"
                            : "mb-[110px]"
                        } ${
                          isShowDropdown === true &&
                          showexit === false &&
                          !errormtravel
                            ? "mb-[160px]"
                            : ""
                        } ${travelloading === false ? " overflow-auto" : ""}`}
                      >
                        {showhomecom === true && travelloading === false ? (
                          alltravelfordriver.map((item) => {
                            return (
                              <div
                                key={item._id}
                                className={`lg:flex   ml-4 mr-4 ${
                                  showexit === false ? "cursor-pointer" : ""
                                } `}
                                onClick={
                                  showexit === false
                                    ? () => showeverytravelc(item)
                                    : null
                                }
                              >
                                <div className="grid grid-rows-2 grid-flow-col w-full lg:w-[100%] h-[74px] bg-white rounded-[10px] shadow-cardtravelshadow1 shadow-cardtravelshadow2 shadow-cardtravelshadow3 ">
                                  <div className="grid grid-cols-2  row-span-1   ">
                                    <div className="flex  col-space-1 text-[14px] lg:text-[12px] lp:text-[14px]">
                                      <img
                                        alt=""
                                        src={begginingimg}
                                        className="w-[12px] h-[20px] mr-4 mt-2 "
                                      />
                                      <p className="relative top-2 whitespace-nowrap pr-4">
                                        {item.origin_city.name}
                                      </p>
                                      <p className="relative top-2 whitespace-nowrap pr-1">
                                        {item.address ? <>,</> : <></>}
                                      </p>
                                      <p className="relative top-2 whitespace-nowrap pr-1">
                                        {item.address ? (
                                          <>
                                            {item.address
                                              .split(" ")
                                              .slice(0, 3)
                                              .join(" ")}
                                            {item.address.split(" ").length > 3
                                              ? "..."
                                              : ""}
                                          </>
                                        ) : (
                                          <p></p>
                                        )}
                                      </p>
                                    </div>
                                    <div className="flex justify-end mt-2 ml-4 text-[14px] font-[400]">
                                      <p className="col-space-1 whitespace-nowrap">
                                        <TimeOnly time={item.travel_date} />
                                      </p>
                                      <p className="col-space-1 whitespace-nowrap">
                                        | {item.travel_hour_time}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="grid grid-cols-2 row-span-1">
                                    <div className="flex col-space-1 text-[14px]">
                                      <div className="mr-4 mt-2">
                                        <img
                                          alt=""
                                          src={destinationimg}
                                          className="w-[12px] h-[20px] "
                                        />
                                      </div>
                                      <p className="relative top-2 whitespace-nowrap pr-4">
                                        {item.destination_city.name}
                                      </p>
                                    </div>
                                    <div className="col-span-1 flex justify-end mt-2 ml-4 text-[14px] font-[400] gap-2">
                                      <p className="text-pricetxcolor whitespace-nowrap">
                                        {item.price}
                                      </p>
                                      <p>تومان</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div
                            className={` w-full flex    items-center justify-center `}
                          >
                            {errormtravel ? (
                              <p>{errormtravel}!</p>
                            ) : (
                              travelloading === true && <Loadingcom />
                            )}
                          </div>
                        )}
                      </div> */}
                                        </div>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <div className=" h-full w-full flex flex-col   items-center justify-center ">
                            <>
                                <div
                                    id="traveldiv"
                                    className=" flex  items-center justify-center  "
                                >
                                    <p className="text-[20px] text-center  text-[black] font-bold">
                                        در انتظار دریافت اطلاعات ...
                                    </p>
                                </div>
                            </>
                        </div>
                    )}
                </>
            ) : (
                <Navigate to="/"/>
            )}
        </>
    );
};
export default TravelCard;
